<template>
  <div class="unsubscribe">
    <img
      v-if="hasValidLogo"
      :src="logo"
      alt="Logo"
      class="logo">
    <template v-if="!hasValidParams">
      <h1>
        <span v-t="'unsubscribe.invalidParams'" />
      </h1>
    </template>
    <template v-else>
      <form
        v-if="!submitted"
        @submit.prevent="submit">
        <div>
          <h1>
            <span v-t="'unsubscribe.title'" />
            <span> {{ accountName }}</span>.
          </h1>
          <p>
            <span v-t="'unsubscribe.question'" />
            <span class="font-bold"> {{ email }}</span>?
          </p>
          <p
            v-t="'unsubscribe.warning'"
            class="text-soft" />
        </div>
        <div>
          <h2 v-t="'unsubscribe.reason'" />
          <div
            v-for="reason in $options.reasons"
            :key="reason">
            <label>
              <input
                v-model="reason_code"
                :value="reason"
                type="radio"
                name="reason">
              <span>
                {{ $t(`unsubscribe.${reason}`) }}
              </span>
            </label>
          </div>
          <button
            v-t="'unsubscribe.action'"
            :disabled="!reason_code"
            class="btn primary" />
        </div>
      </form>
      <div v-else>
        <h1 v-if="error">
          <span v-t="'unsubscribe.error'" />
        </h1>
        <h1 v-else>
          <span v-t="'unsubscribe.success'" />
          <span> {{ accountName }}</span>.
        </h1>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import parseDecode from '@/helpers/parseDecode';
import hasLogo from '@/mixins/hasLogo';

export default {
  mixins: [hasLogo],
  reasons: [
    'not_interested',
    'too_frequent',
    'spam_never_subscribed',
    'spam_offensive',
  ],
  data() {
    return {
      email: null,
      accountName: null,
      account: null,
      apiUrl: null,
      reason_code: '',
      submitted: false,
      error: false,
    };
  },
  computed: {
    hasValidParams() {
      return (
        this.email &&
        this.account &&
        this.accountName &&
        this.apiUrl
      );
    },
    packet() {
      return this.$route.query.p;
    },
  },
  created() {
    document.title = this.$t('unsubscribe.pageTitle');
  },
  beforeMount() {
    this.parseParams();
    this.preloadLogo();
  },
  methods: {
    parseParams() {
      const params = parseDecode(this.$route.query.d);
      if (!params) return false;
      this.email = params.e;
      this.account = params.a;
      this.accountName = params.n;
      this.apiUrl = params.u;
      return true;
    },
    submit() {
      const url = this.apiUrl.replace('{packet}', this.packet);
      axios.post(`${url}?r=${this.reason_code}`).then(() => {
        this.submitted = true;
      }).catch(() => {
        this.submitted = true;
        this.error = true;
      });
    },
  },
};
</script>
